import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useIsSuperAdmin() {
  return useQuery({
    queryKey: ["super-admin"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data: profile } = await supabase
        .from("profiles")
        .select("is_super_admin")
        .eq("id", user.id)
        .single();

      return profile?.is_super_admin ?? false;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
